import React from "react"
//import I18n from "i18n-js/index.js.erb"

class PropertyCalendarRoomCell extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="PropertyCalendarRoomCell" style={this.generateStyle()}>
				{this.props.room ? this.renderRoom() : this.renderRoomGroup()}
			</div>
		);
	}

	renderRoom() {
		if (this.props.room) {
	
			return (
				<span>
					{this.props.room.identifier}
					{this.props.show_housekeeping && this.props.room.housekeeping_status && this.props.room.occupancy_status ? <span className="HousekeepingStatus">{I18n.t(this.props.room.occupancy_status == "vacant" ? this.props.room.housekeeping_status : 'occ')}</span> : null}
				</span>
			);
    }
  }
  
	renderRoomGroup() {
		if (this.props.room_group) {
      return (
        <span>
          {this.props.room_group.identifier}
          {this.props.show_housekeeping && this.props.room_group.housekeeping_status && this.props.room_group.occupancy_status ? <span className="HousekeepingStatus">{I18n.t(this.props.room_group.occupancy_status == "vacant" ? this.props.room_group.housekeeping_status : 'occ')}</span> : null}
        </span>
      );
    } else {
      return ""
    }
	}

	generateStyle() {
		if (typeof this.props.top != 'undefined' && typeof this.props.left != 'undefined') {
			return {top: this.props.top + 'px', left: this.props.left + 'px'};
		} else {
			return {top: this.props.top + 'px'};
		}
	}

}

export default PropertyCalendarRoomCell